<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>
    <mat-tab-group mat-stretch-tabs>
        <!-- Shedules -->
        <mat-tab label="{{'shedulesComponent.time' | translate}}">
            <ng-template mat-tab-label>
                <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center">
                    <span class="text-base font-bold">{{'shedulesComponent.time' | translate}}</span>
                </div>
            </ng-template>
            <div #shedulesCont class="mx-4 mt-4 rounded-md bg-white shadow-sm border">
                <ul class="space-y-3 text-sm">
                    <li class="flex flex-row items-center px-4 py-2.5" *ngFor="let item of nextDays">
                        <div class="flex-1 flex items-center gap-2.5">
                            <i *ngIf="!item.date.isSame(today, 'day')"
                                class="material-icons text-gray-400">calendar_today</i>
                            <i *ngIf="item.date.isSame(today, 'day')" class="material-icons text-blue-500">today</i>
                            <div class="text-gray-700" [ngClass]="item.date.isSame(today, 'day') ? 'font-bold' : ''">
                                {{ item.date.format('dddd') | capitalize }}
                                <span class="text-gray-400">({{ item.date.format('DD/MM') }})</span>
                            </div>
                        </div>

                        <!-- fermé exceptionnel -->
                        <div class="text-red-700 text-sm font-semibold" *ngIf="isClosedForDate(item.date)">
                            {{ 'shedulesComponent.exceptionally_closed' | translate }}
                        </div>

                        <!-- sinon horaires -->
                        <div *ngIf="!isClosedForDate(item.date)">
                            <ng-container *ngIf="(item.timetable?.timeslots?.length ?? 0) > 0; else closedByDefault">
                                <div *ngFor="let slot of item.timetable?.timeslots ?? []" class="text-gray-600">
                                    {{ slot.start | sheduleFilter }} - {{ slot.end | sheduleFilter }}
                                </div>
                            </ng-container>
                            <ng-template #closedByDefault>
                                <div class="text-red-700 text-sm font-semibold">
                                    {{ 'shedulesComponent.closed' | translate }}
                                </div>
                            </ng-template>
                        </div>
                    </li>
                </ul>
            </div>
        </mat-tab>

        <!-- Closing -->
        <mat-tab label="{{'shedulesComponent.close' | translate}}"
            *ngIf="closings.length > 0 && (point_of_sale.closings?.length ?? 0) > 0">
            <ng-template mat-tab-label>
                <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center">
                    <span class="mat-subheading-1 boldest"> {{'shedulesComponent.close' | translate}} </span>
                </div>
            </ng-template>
            <div [ngStyle]="{'height.px' : contHeight}">
                <div fxLayout="column" fxLayoutAlign="center center" class="full-screen">
                    <div *ngFor="let period of closings; let last = last;" class="text-center layout-padd-2"
                        [class.divider]="!last">
                        <div *ngIf="period.date_from!==period.date_to">
                            <span class="mat-subheading-1">{{'shedulesComponent.of' | translate}} <strong>
                                    {{period.date_from | dateFilter:"dddd DD MMMM"}}
                                </strong> {{'shedulesComponent.at' | translate}}
                                <strong>{{period.date_to | dateFilter:"dddd DD MMMM"}}</strong>
                            </span>
                        </div>
                        <div *ngIf="period.date_from===period.date_to">
                            <span class="mat-subheading-1">{{'shedulesComponent.the' | translate}}
                                <strong>{{period.date_from | dateFilter:"dddd DD MMMM"}}</strong>
                            </span>
                        </div>
                        <div *ngIf="period.date_from===period.date_to && period.hour_from &&period.hour_to ">
                            <span class="mat-subheading-1">{{'shedulesComponent.ofend' | translate}}
                                <strong>{{period.hour_from }}</strong>
                                {{'shedulesComponent.to' | translate}}
                                <strong>{{period.hour_to }}</strong> </span>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="p-4 ">
        <button [ngClass]="cssService.defaultActionButton" class="w-full" (click)="closeDial()" angulartics2On="click"
            angularticsAction="closeShedulesDial" angularticsCategory="pointOfSale">
            <span>{{"dialogs.go-back" | translate}}</span>
        </button>
    </div>
</div>